const AtomsBreakline = (props) => {
    const builder = Array(props.length).fill(1)

    return (
        <>
            {
                builder.map((_, i) => {
                    return <br key={i}></br>
                })
            }
        </>
    )
}
  
export default AtomsBreakline
